module.exports = __webpack_public_path__ + "img/background.d5f09a51.png";